import { render, staticRenderFns } from "./VehicleDetails.vue?vue&type=template&id=37cea4d2&scoped=true"
import script from "./VehicleDetails.vue?vue&type=script&lang=js"
export * from "./VehicleDetails.vue?vue&type=script&lang=js"
import style0 from "./VehicleDetails.vue?vue&type=style&index=0&id=37cea4d2&prod&lang=css"
import style1 from "./VehicleDetails.vue?vue&type=style&index=1&id=37cea4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37cea4d2",
  null
  
)

export default component.exports